import React from "react";
import {
	Box,
	Flex,
	Text,
	HStack,
	Stack,
	Switch,
	Input,
	Button,
	Icon,
	Spacer,
	SimpleGrid,
} from "@chakra-ui/react";
import { BsCheckCircle } from "react-icons/bs";

function Settings() {
	return (
		<Box pt={{ base: "120px", md: "75px" }}>
			<SimpleGrid columns={{ sm: 1, md: 2, lg: 2 }} gap={10}>
				<Flex direction="column" gap={5}>
					<Text fontSize="20px" fontWeight="bold">
						Two-factor authentication
					</Text>
					<Stack direction="row">
						<Switch size="lg" />
						<Text fontSize="15px">Two-Factor Authentication</Text>
					</Stack>
					<Stack direction="column" spacing={5}>
						<Text fontSize="15px">Phone Number</Text>
						<Flex gap={4} align="center">
							<Input
								placeholder="Type your Phone Number"
								bg="#3D3D44"
								size="lg"
							/>
							<Button bg="#16BF5D" py="12px" px="24px">
								Send SMS
							</Button>
						</Flex>
					</Stack>
				</Flex>

				<Flex direction="column" gap={5}>
					<Text fontSize="20px" fontWeight="bold">
						Devices Used
					</Text>
					<Stack direction="column" spacing={5}>
						<Flex direction="row" gap={5}>
							<Text fontSize="15px" fontWeight="bold">
								Windows
							</Text>
							<Text fontSize="15px">Google Chrome</Text>
							<Text fontSize="15px">Stockholm-SE</Text>
							<Flex marginLeft="auto" align="center">
								<Icon as={BsCheckCircle} color="#71C9EC" mr={2} />
								<Text fontSize="15px" fontWeight="bold">
									Your Current Session
								</Text>
							</Flex>
						</Flex>
						{[1, 2, 3].map((item, i) => (
							<Flex key={i} direction="row" gap={5}>
								<Text fontSize="15px" fontWeight="bold">
									Windows
								</Text>
								<Text fontSize="15px">Google Chrome</Text>
								<Text fontSize="15px">Stockholm-SE</Text>
								<Flex marginLeft="auto" align="center">
									<Button>Logout</Button>
								</Flex>
							</Flex>
						))}
					</Stack>
				</Flex>
			</SimpleGrid>
			<Stack direction="column" spacing={5}>
				<Text fontSize="20px" fontWeight="bold">
					Account Activity
				</Text>
				{[1, 2, 3, 4, 5].map((item, i) => (
					<HStack spacing={3} key={i}>
						<Text fontSize="15px" fontWeight="bold">
							API Creation
						</Text>
						<Text fontSize="15px" color="#E0E0E0">
							2 Tokens
						</Text>
						<Text fontSize="15px" color="#E0E0E0">
							20.04.2023 09:00:00 CEST
						</Text>
					</HStack>
				))}
			</Stack>
		</Box>
	);
}

export default Settings;
